// Maps a failed /v2/help/chat fetch response into the message shown to the
// user. Most failures are unexpected (network blip, unhandled server error)
// and should show a generic, safe message rather than raw response detail.
// The one exception is a 429 (rate limited): its JSON body's `message` is a
// server-authored, safe-to-display string (see Gitcha-API's
// helpChatRateLimit.middleware.js: 'Too many chat messages. Please wait a
// moment and try again.'), not raw error detail - so it's shown directly
// instead of being flattened into the same generic fallback a hung
// connection or a 500 gets.
export const GENERIC_CHAT_ERROR_MESSAGE =
  "Something went wrong on my side. You can send a ticket to support and the team will follow up.";

const DEFAULT_RATE_LIMIT_MESSAGE =
  "You're sending messages too quickly. Please wait a moment and try again.";

export async function messageForFailedResponse(response) {
  if (response.status === 429) {
    try {
      const body = await response.json();
      if (body && typeof body.message === "string" && body.message.trim()) {
        return body.message;
      }
    } catch (_e) {
      // Body wasn't JSON (or was empty) - fall through to the default below.
    }
    return DEFAULT_RATE_LIMIT_MESSAGE;
  }
  return GENERIC_CHAT_ERROR_MESSAGE;
}
